export const archiveAccordion = () => {
  if (location.pathname == '/archive') {
    const years = document.querySelectorAll('.archive-year')
    years.forEach((y) =>
      y.addEventListener('click', () => y.classList.toggle('open')),
    )
  }
}
